<template>
  <div id="app">
    <loading/>
    <router-view />
  </div>
</template>
<script>
import loading from './components/loading/loading.vue';
export default {
  components:{
    loading
  },
  data() {
    return {
      isDev: false,
    }
  },
  created() {
    if (process.env.VUE_APP_TYPE == 'dev') {
      this.isDev = true
    }

  },
  computed: {
    isReconnecting() {
      return this.$store.getters["customerService/isReconnecting"];
    },
  },
  methods: {
    // 初始化客服系统
    initCustomerService() {
      this.$store.dispatch("customerService/initCustomerService");
    },
    // 打开客服聊天窗口
    openChat() {
      this.$store.dispatch("customerService/openChat");
    },
    // 获取未读消息
    getUnreadMessages() {
      this.$store.dispatch("customerService/getUnreadMessages");
    },
  },
  mounted() {
    // 在组件加载时初始化客服系统
    this.initCustomerService();
  },
};

</script>
<style lang="scss">
@use "~@/assets/style/reset.scss" as *;

#app{
  background-image: url(~@/assets/image/home/home_bg.png);
  background-size: 698px 220px;
  background-position: top right;
  background-repeat: no-repeat;
  min-height: 100%;
}
:root{
  --el-drawer-padding-primary: 16px;
}


// #app {
//   min-height: 100vh;
//   display: flex;
//   /* 让 #app 成为弹性容器 */
//   flex-direction: column;
// }

.primary {
  color: #0062FF !important;
}

.pointer {
  cursor: pointer;
}
.keep2lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.viewer-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.border {
  background: #ffffff;
  border-radius: 4px;
  background-color: #fff;
}

.DEVnotify {
  width: 400px !important;
  cursor: pointer;

  &_iconClass {
    width: 60px !important;
    height: 60px !important;
    display: block;
    background-image: url(~@/static/profile_picture.png);
    background-size: 60px;

  }

  .el-notification__group {
    width: calc(400px - 100px - 13px - 8px) !important;
  }
}

.service-code {
  background-image: url(~@/static/code.jpg);
  background-size: 100%;
}
.cancelButtonClass{
  @include buttonStyle
}
.confirmButtonClass{
  @include buttonStyle
}
</style>
